import { CustomElement } from '../types';

export const serializeToHtml = (nodes: CustomElement[]): string => {
  // TODO: Implement HTML serialization
  console.log('Serialize to HTML:', nodes);
  return '<div>HTML serialization not implemented yet</div>';
}; 